import { render, staticRenderFns } from "./studyfileChoose.vue?vue&type=template&id=b9e0382c&"
import script from "./studyfileChoose.vue?vue&type=script&lang=js&"
export * from "./studyfileChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports